'use client';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:tillamook-com":true});}catch(e){}}();

import React, { useEffect, useRef, useState } from 'react';

import cx from 'classnames';
import copy from 'clipboard-copy';
import PropTypes from 'prop-types';

import SvgIcon from 'components/ui/SvgIcon';
import Text from 'components/ui/Text';

import styles from './Share.module.scss';

const Share = ({ url }) => {
    const copylinkRef = useRef(null);
    const [linkCopied, setLinkCopied] = useState(false);

    useEffect(() => {
        const handleOutsideClick = event => {
            if (
                copylinkRef?.current &&
                !copylinkRef?.current.contains(event.target)
            ) {
                setLinkCopied(false);
            }
        };

        // outside click event cannot be on the window, because react bypasses synthetic events on the window
        // this means the ref never contains the event target at the time of the outside click
        // listening on the main node makes react use a synthetic event, now we can check if the ref contains the target
        const mainNode = document.querySelector('main');
        mainNode.addEventListener('click', handleOutsideClick);

        return () => {
            mainNode.removeEventListener('click', handleOutsideClick);
        };
    }, []);

    const handleLinkClick = () => {
        copy(url);
        setLinkCopied(true);
    };

    return (
        <div
            ref={copylinkRef}
            className={cx(styles.root, {
                [styles.linkCopied]: linkCopied,
            })}
        >
            <Text className={styles.label} baseTheme="labelSmall">
                SHARE:
            </Text>
            <div className={styles.copylink} onClick={handleLinkClick}>
                <div className={styles.tooltip}>
                    <svg width="130" height="51" viewBox="0 0 130 51">
                        <rect
                            x="53"
                            y="39"
                            width="16.9707"
                            height="16.9707"
                            transform="rotate(-45 53 39)"
                            fill="currentColor"
                        />
                        <rect
                            width="130"
                            height="42"
                            rx="4"
                            fill="currentColor"
                        />
                    </svg>
                    <Text
                        baseTheme="headingXSmall"
                        className={styles.tooltipText}
                    >
                        Link copied!
                    </Text>
                </div>
                <SvgIcon className={styles.icon} type="link" />
                <span className="sr-only">copy link</span>
            </div>
        </div>
    );
};

Share.propTypes = {
    url: PropTypes.any,
};

export default Share;
